module.exports = __webpack_public_path__ + "img/close.844f377e.svg";